import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import CartIQFOMO from "@/pages/CartIQFOMO";
import AuthCallback from "@/pages/AuthCallback";
import Pricing from "@/pages/Pricing";
import UploadPage from "@/pages/UploadPage";
import FeedbackPage from "@/pages/FeedbackPage";
import IntelligenceTab from "@/pages/IntelligenceTab";
import IntentGate from "@/pages/IntentGate";
import MobileAuthBridge from "@/pages/MobileAuthBridge";
import SmartCartDemo from "@/pages/SmartCartDemo";
import { TermsPage, PrivacyPage } from "@/pages/LegalPages";
import AdminDashboard from "@/pages/AdminDashboard";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect session_id during render BEFORE any other route renders.
  // This avoids race conditions with the AuthProvider /me check.
  //
  // EXCEPTION: /auth/mobile-bridge is the React Native deep-link handoff.
  // It legitimately receives `#session_id=...` and must NOT be hijacked by
  // the web AuthCallback (which would set a cookie + redirect to /dashboard
  // instead of bouncing the user into the mobile app via cartiq360://).
  if (
    location.hash?.includes("session_id=") &&
    location.pathname !== "/auth/mobile-bridge"
  ) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/fomo" element={<CartIQFOMO />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/upload" element={<UploadPage />} />
      <Route path="/feedback" element={<FeedbackPage />} />
      <Route path="/intelligence" element={<IntelligenceTab />} />
      <Route path="/spending" element={<IntentGate tab="spending" />} />
      <Route path="/budget" element={<IntentGate tab="budget" />} />
      <Route path="/dashboard/:reportId" element={<Dashboard />} />
      <Route path="/auth/mobile-bridge" element={<MobileAuthBridge />} />
      <Route path="/smart-cart" element={<SmartCartDemo />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors theme="light" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
